// extracted by mini-css-extract-plugin
export default {"SuggestList":"DJuod","selected":"CKN0m"};